import { testDriveMember } from "../mockMembers";
import { getMockPolicies } from "../builders/getMockPolicies";

import { MockPersona } from "./mockPersonas.types";

const policies = getMockPolicies(
  // No autopay, has ID card
  "5R34843-01",
  "5R34843-02",
  // No autopay, comp only
  "EA108939-00",
  "EA108939-01",
  // Autopay, has ID card
  "7K903235-01",
  "7K903235-02",
  // Autopay, comp only
  "0P456325-00",
  "0P456325-01",
);

export const matDuncan: MockPersona = {
  key: "matDuncan",
  name: "Mat Duncan",
  description: "🇺🇸 | Multiple policies with documents and statements, no bills, no HDC",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: policies,
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "mat@duncan.com",
            firstName: "Mat",
            middleName: "",
            lastName: "Duncan",
            mailingAddress: {
              line1: "1149 Tower Road",
              line2: "",
              city: "Beverly Hills",
              state: "CA",
              postalCode: "90210",
              country: "USA",
            },
            preferredPhone: "3025551212",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000022",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
